import React from 'react';
import classNames from 'classnames';

import * as styles from './Card.css';
import * as hoverStyles from './CardHover.css';

import { LinkArea } from '../LinkArea';

export interface ICardProps {
  promoted: boolean;
  colored: boolean;
  href: string;
  content: React.ReactNode;
  gallery: React.ReactNode;
  thumbnails: React.ReactNode;
  agent: React.ReactNode;
  controls: React.ReactNode;
  vas: React.ReactNode;
  pessimization: React.ReactNode;
  comment: React.ReactNode;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function CardComponent({
  onClick,
  href,
  promoted,
  gallery,
  thumbnails,
  controls,
  pessimization,
  comment,
  vas,
  colored,
  content,
  agent,
}: ICardProps) {
  return (
    <article className={classNames(styles['container'], hoverStyles['cont'], colored && styles['colored'])}>
      <div className={classNames(styles['card'], hoverStyles['card'], promoted && styles['promoted'])}>
        <div className={styles['media']} onClick={onClick}>
          {gallery}
          {thumbnails}
        </div>
        <div className={styles['content']}>
          <div className={styles['general']}>
            <LinkArea className={styles['link']} href={href} preventDefault onClick={onClick}>
              {content}
            </LinkArea>
          </div>
          <div className={styles['aside']}>
            <div className={styles['agent-cont']} onClick={onClick}>
              <div className={styles['agent']}>{agent}</div>
              <div className={styles['buttons']} onClick={e => e.stopPropagation()}>
                {controls}
              </div>
            </div>
            <div className={styles['vas']}>{vas}</div>
          </div>
        </div>
      </div>
      <div className={styles['comments']}>
        {pessimization}
        {comment}
      </div>
    </article>
  );
}

export const Card = React.memo(CardComponent);
